export const cableOrExtenderQuery = `
  fragment CableOrExtenderFields on CableOrExtender {
    productName {
      value
    }
    brand {
      value
    }
    productType {
      value
    }
    uSBConnectionType {
      value
    }
    uSBSpecification {
      value
    }
    length {
      value
    }
    disclaimer {
      value
    }
    region {
      targetItems {
        name
      }
    }
    compatibleProduct {
      targetItems {
        name
      }
    }
    link {
      url
    }
  }
  query CableOrExtenderQuery($path: String!, $language: String!, $first: Int!) {
    item(path: $path, language: $language) {
      children(first: $first) {
        results {
          id
          ...CableOrExtenderFields
        }
      }
    }
  }
`;
export const hubOrDockQuery = `
  fragment HubOrDockFields on HubOrDock {
    productName {
      value
    }
    brand {
      value
    }
    productType {
      value
    }
    hostInterface {
      value
    }
    maxDisplays {
      value
    }
    uSBPorts {
      value
    }
    videoPorts {
      value
    }
    disclaimer {
      value
    }
    region {
      targetItems {
        name
      }
    }
    compatibleProduct {
      targetItems {
        name
      }
    }
  }
  query HubOrDockQuery($path: String!, $language: String!, $first: Int!) {
    item(path: $path, language: $language) {
      children(first: $first) {
        results {
          id
          ...HubOrDockFields
        }
      }
    }
  }
`;
export const hdmiCableOrExtenderQuery = `
  fragment HDMICableOrExtenderFields on HDMICableOrExtender {
    productName {
      value
    }
    brand {
      value
    }
    productType {
      value
    }
    hDMISpecification {
      value
    }
    length {
      value
    }
    compartmentCoverCompatbile {
      value
    }
    disclaimer {
      value
    }
    region {
      targetItems {
        name
      }
    }
    compatibleProduct {
      targetItems {
        name
      }
    }
    link {
      url
    }
  }
  query HDMICableOrExtenderQuery($path: String!, $language: String!, $first: Int!) {
    item(path: $path, language: $language) {
      children(first: $first) {
        results {
          id
          ...HDMICableOrExtenderFields
        }
      }
    }
  }
`;
export const wirelessConferencingQuery = `
  fragment WirelessConferencingFields on WirelessConferencing {
    productName {
      value
    }
    brand {
      value
    }
    productType {
      value
    }
    productFirmware {
      value
    }
    jabraFirmware {
      value
    }
    productSoftwareVersion {
      value
    }
    disclaimer {
      value
    }
    region {
      targetItems {
        name
      }
    }
    compatibleProduct {
      targetItems {
        name
      }
    }
  }
  query WirelessConferencingQuery($path: String!, $language: String!, $first: Int!) {
    item(path: $path, language: $language) {
      children(first: $first) {
        results {
          id
          ...WirelessConferencingFields
        }
      }
    }
  }
`;
export const cableGuideEntries = `
  query ($language: String!, $path: String!) {
    item(path: $path, language: $language) {
      children {
        results {
          path
        }
      }
    }
  }
`;
